"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSeaview = function SvgSeaview(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 2)",
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.507c.878-.343 1.587-1.023 2.128-2.042 1.2 1.79 4.323 2.2 5.856 0 1.713 1.483 4.406 2.507 5.933 0 .72.733 1.747 1.595 2.925 1.529M0 19.292c.878-.343 1.587-1.023 2.128-2.041 1.2 1.79 4.323 2.2 5.856 0 1.713 1.483 4.406 2.507 5.933 0 .72.733 1.747 1.594 2.925 1.528"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.053,
    cy: 6.599,
    r: 2.632
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.133 8.014 2.716 9.46M6.63 5.739l-5.319-.65m7.161-1.757-3.3-2.125m5.893.566V0m3.106 3.613 1.801-1.41M15.203 6.6h2.15m-2.745 2.356 2.157 1.54"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSeaview);
var _default = exports["default"] = Memo;